import PropTypes from 'prop-types'
import Button from 'components/shared/Button/Button'
import Icon from 'components/shared/Icon/Icon'

import { withTranslation } from 'react-i18next'

import './CodeClubWorldCard.scss'

export const CodeClubWorldCard = ({ t }) => {
  return (
    <div className="c-code-club-world-card">
      <div className="c-code-club-world-card__wrapper">
        <div className="c-code-club-world-card__text">
          <h2 className="c-code-club-world-card__title">
            {t('homepage.code-club-world.title')}
          </h2>
          <p className="c-code-club-world-card__description">
            {t('homepage.code-club-world.body')}
          </p>
          <Button
            className="c-code-club-world-card__button"
            textAlways
            icon={<Icon type="external-link" />}
            iconAlignment="right"
            type="primary"
            text={t('homepage.code-club-world.button.text')}
            href="https://codeclubworld.org/"
          />
        </div>
        <div className="c-code-club-world-card__image">
          <img
            src="/images/code-club-world-children-coding.png"
            alt={t('homepage.code-club-world.image_alt')}
          />
        </div>
      </div>
    </div>
  )
}

CodeClubWorldCard.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withTranslation('translations')(CodeClubWorldCard)
